import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { AdmBtnItem, AdminWrap, Center, ContentWrap, InputWrap, ItemWrap, Row } from '../../../../style/basic/commonStyle';
import BasicText from '../../../basic/BasicText';
import { Grid } from '@mui/material';
import { fileTypeRes } from '../../../../utils/format/string';
import { apiAdmGetCommonImg, apiAdmSetCommonImg } from '../../../../api/api_adm_product';
import { useAdminUser } from '../../../../utils/custom-hooks/common/useAdminUser';

export default function AdminProductCommonPage() {
    const topRef = useRef<any>(null);
    const bottomRef = useRef<any>(null);
    const adminUser=  useAdminUser();
    const [info,setInfo] = useState({
        phone_desc_image_top: '',
        phone_desc_image_bottom: '',
    });
    const [topImg,setTopImg] = useState({
        file: null,
        img: '',
    });
    const [bottomImg,setBottomImg] = useState({
        file: null,
        img: '',
    });

    useEffect(()=>{
        if(adminUser.admin_token === '') return;
        getInfo();
    },[adminUser.admin_token])

    const getInfo = async() =>{
        const res = await apiAdmGetCommonImg(adminUser.admin_token,adminUser.admin_id);
        if(res.result){
            setInfo(res.data);
        }
    }

    const clickAction = (el:any) =>{
        el.current.click();
    }

    const imgSelect = (e:any,el:any,setImg:any) =>{
        const file = e.target.files[0];
        
        if(file){
            const fileFormat = fileTypeRes(file.name);
            
            if(fileFormat === 'png' || fileFormat === 'jpg' || fileFormat === 'gif'){
                const preImg = URL.createObjectURL(file);
                const reader = new FileReader();
                reader.onload = () => {
                    const result = reader.result;
                    setImg((obj:any)=>({...obj,file:result,img:preImg}));
                };

                reader.readAsDataURL(file);
            }else{
                alert('확장자가 png, jpg, gif 이미지 파일만 가능합니다.');
                el.current.value = null;
            }
        }
    }

    // 수정
    const changeAction = async() =>{
        const res = await apiAdmSetCommonImg(adminUser.admin_token,adminUser.admin_id,
            topImg.file ?? '', bottomImg.file ?? '',
        )
        if(res.result){
            alert('수정 되었습니다');
        }else{
            alert(res.error);
        }
    }

    return (
        <Wrap>
            <AdminWrap>
                <BasicText fontSize={18} mFontSize={16} fontWeight={700}>공통 이미지 관리</BasicText>
                <InnerWrap>
                    <Grid container={true} spacing={2}>
                        <Grid item md={6} xs={12}>
                            <ContentWrap>   
                                <ItemWrap pWidth={120} align='start'>
                                    <BasicText marginTop={1}>상단 이미지</BasicText>
                                    <div style={{width:'100%'}}>
                                        <ItemWrap gap='15px'>
                                            <ImgBtnWrap onClick={()=>clickAction(topRef)}>파일 업로드</ImgBtnWrap>
                                        </ItemWrap>
                                        <input style={{display:'none'}} ref={topRef} type='file' accept='.png,.jpg,.gif' onChange={(e:any)=>imgSelect(e,topRef,setTopImg)}></input>
                                        <ImgWrap>
                                            {(info.phone_desc_image_top !=='' || topImg.img !== '') &&
                                                <img style={{maxWidth:'100%',maxHeight:'280px'}} src={topImg.img === '' ? info.phone_desc_image_top : topImg.img}></img>
                                            }
                                        </ImgWrap>
                                    </div>
                                </ItemWrap>
                                <ItemWrap pWidth={120} align='start'>
                                    <BasicText marginTop={1}>하단 이미지</BasicText>
                                    <div style={{width:'100%'}}>
                                        <ItemWrap gap='15px'>
                                            <ImgBtnWrap onClick={()=>clickAction(bottomRef)}>파일 업로드</ImgBtnWrap>
                                        </ItemWrap>
                                        <input style={{display:'none'}} ref={bottomRef} type='file' accept='.png,.jpg,.gif' onChange={(e:any)=>imgSelect(e,bottomRef,setBottomImg)}></input>
                                        <ImgWrap>
                                            {(info.phone_desc_image_bottom !=='' || bottomImg.img !== '') &&
                                                <img style={{maxWidth:'100%',maxHeight:'280px'}} src={bottomImg.img === '' ? info.phone_desc_image_bottom : bottomImg.img}></img>
                                            }
                                        </ImgWrap>
                                    </div>
                                </ItemWrap>
                            </ContentWrap>
                            <Row style={{marginTop: '50px'}}>
                                <AdmBtnItem onClick={changeAction} bg='#18A40E'>공통 이미지 관리</AdmBtnItem>
                            </Row>
                        </Grid>
                    </Grid>
                </InnerWrap>
            </AdminWrap>
        </Wrap>
    )
}

const Wrap = styled.div``;
const InnerWrap = styled.div`
    margin-top: 30px;
`;
const ImgBtnWrap = styled(Center)`
    cursor: pointer;
    border: 1px solid #e6e6e6;
    padding: 12px 14px;
    border-radius: 6px;
    flex-shrink: 0;
    width: 100%;
`;

const ImgWrap = styled.div`
    margin-top: 10px;
    width: 100%;
    max-height: 380px;
    overflow-y: auto;
    & img{
        max-width: 100%;
    }
`;